const validateCnpj = (s = '') => {
    let cnpj = s.replace(/[^\d]+/g, '')

    // Valida a quantidade de caracteres
    if (cnpj.length !== 14)
        return false

    // Elimina inválidos com todos os caracteres iguais
    if (/^(\d)\1+$/.test(cnpj))
        return false

    // Cáculo de validação
    let t = cnpj.length - 2,
        d = cnpj.substring(t),
        d1 = parseInt(d.charAt(0)),
        d2 = parseInt(d.charAt(1)),
        calc = (x: number) => {
            let n: any = cnpj.substring(0, x),
                y = x - 7,
                s = 0,
                r = 0

            for (let i = x; i >= 1; i--) {
                s += n.charAt(x - i) * y--;
                if (y < 2)
                    y = 9
            }

            r = 11 - s % 11
            return r > 9 ? 0 : r
        }

    return calc(t) === d1 && calc(t + 1) === d2
}

const validateCpf = (s = '') => {
    let cpf = s.replace(/[^\d]+/g, '')

    var sum;
    var mod;
    sum = 0;
    if (cpf === "00000000000") return false;

    for (let i = 1; i <= 9; i++) sum = sum + parseInt(cpf.substring(i - 1, i)) * (11 - i);
    mod = (sum * 10) % 11;

    if ((mod === 10) || (mod === 11)) mod = 0;
    if (mod !== parseInt(cpf.substring(9, 10))) return false;

    sum = 0;
    for (let i = 1; i <= 10; i++) sum = sum + parseInt(cpf.substring(i - 1, i)) * (12 - i);
    mod = (sum * 10) % 11;

    if ((mod === 10) || (mod === 11)) mod = 0;
    if (mod !== parseInt(cpf.substring(10, 11))) return false;
    return true;
}

export const requiredValidator = function (value: string) {
    return value ? "" : "Este campo é obrigatório.";
}

export const requiredCepValidator = function (value: string) {
    if (!value) return "Este campo é obrigatório.";

    const onlyNumbers = value?.replace(/[^\d]+/g, '');
    return onlyNumbers.length === 8 ? "" : "CEP inválido.";
}

export const cnpjValidator = function (value: string) {
    const onlyNumbers = value?.replace(/[^\d]+/g, '');
    return onlyNumbers === "" || validateCnpj(onlyNumbers) || !onlyNumbers ? "" : "CNPJ inválido.";
}

export const cpfValidator = function (value: string) {
    const onlyNumbers = value?.replace(/[^\d]+/g, '');
    return onlyNumbers === "" || validateCpf(onlyNumbers) || !onlyNumbers ? "" : "CPF inválido.";
}
